import Lookup from './lookup.js';

export default class FileName extends Lookup
{
    constructor(id, name, title, fileRelationship, active, description, size, extensions, created_at = null, updated_at = null) {
        super()
        this.id                 = id ?? 0
        this.name               = name
        this.title              = title
        this.fileRelationship   = fileRelationship
        this.active             = active
        this.description        = description
        this.size               = size
        this.extensions         = extensions
        this.created_at         = created_at??null
        this.updated_at         = updated_at??null
        this.init()
    }
}
